import React, { useMemo } from 'react'
import './styles.scss'

import { AgGridReact } from '@ag-grid-community/react'
import { PaginationChangedEvent } from '@ag-grid-community/core'
import { AgGridPaginationProps } from './types'
import {
  DEFAULT_PAGINATION_PAGE_SIZE,
  DEFAULT_PAGINATION_PAGE_SIZES,
} from '../../constants'

const AgGridPagination = (props: AgGridPaginationProps) => {
  const { totalSize, setCurrentPage, setPageSize, ...rest } = props

  const rowData = useMemo(() => {
    return Array.from(Array(totalSize)).map((_, index) => ({
      id: index,
    }))
  }, [totalSize])

  const onPaginationChanged = (params: PaginationChangedEvent) => {
    const api = params.api
    const currentPage = api.paginationGetCurrentPage() + 1
    const pageSize = api.paginationGetPageSize()
    setCurrentPage(currentPage)
    setPageSize(pageSize)
  }

  return (
    <div className="ag-theme-alpine ag-grid-pagination">
      <AgGridReact
        getRowId={({ data }) => data.id}
        pagination
        paginationPageSize={DEFAULT_PAGINATION_PAGE_SIZE}
        rowData={rowData}
        columnDefs={[{ field: 'id' }]}
        paginationPageSizeSelector={DEFAULT_PAGINATION_PAGE_SIZES}
        onPaginationChanged={onPaginationChanged}
        {...rest}
      />
    </div>
  )
}

export default AgGridPagination
